export default __webpack_public_path__ + "static/media/dashboard-new.b87691ab.svg";